<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isSysAdmin() || $gate.isServiceAdmin()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<!-- main row for all icons  -->
<div class="col-lg-12">
	<div class="card card-danger ">
		<div class="card-header">
			Manage Add On Services
		</div>
		<div class="card-body overflow-auto">
				<table class="table table-striped table-bordered table-hover">
						<thead>
							<tr>
								<th>Code</th>
								<th>Name</th>
								<th>Item Code</th>
								<th>Lower Limit</th>
								<th>Upper Limit</th>
								<th>MOP</th>
								<th>Validity</th>
								<th>Coverage Term</th>
								<th>Change</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="j in services" :key="j.id">
								<td>{{j.aos_code}}</td>
								<td>{{j.name}}</td>
								<td>{{j.item_code}}</td>
								<td>{{j.lower_limit}}</td>
								<td>{{j.upper_limit}}</td>
								<td>{{j.mop}}</td>
								<td>{{j.validity}}</td>
								<td>{{j.coverage_term}}</td>
								<td>
									<button class="btn btn-success fa fa-play" v-if="j.validity == 'Inactive'" @click="changeService(j.id, 'Active')"></button>
									<button class="btn btn-danger fa fa-square" v-else-if="j.validity == 'Active'" @click="changeService(j.id, 'Inactive')"></button>
									<button class="btn btn-danger fa fa-trash" @click="changeService(j.id, 'Deleted')"></button>
								</td>
							</tr>
						</tbody>
					</table>
    </div>
    <div class="card-footer">
				<div class="col-sm-12">
    				<div class="row">
    					<div :class="['form-group', errors.item_code ? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="form.item_code" placeholder="Enter new item code">
    						<span v-if="errors.item_code" :class="['badge bg-danger']">Please enter a valid item code.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="itemSearch">Search</button>
    					</div>
    					<div :class="['form-group', errors.aos_code? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="form.aos_code" placeholder="Enter new AOS code">
    						<span v-if="errors.aos_code" :class="['badge bg-danger']">Please enter a valid AOS code.</span>
    					</div>
    					<div :class="['form-group', errors.name? 'has-error' : '']">
    						<input type="text" class="form-control" v-model="form.name" placeholder="Enter new name">
    						<span v-if="errors.name" :class="['badge bg-danger']">Please enter a valid name.</span>
    					</div>
    					<div :class="['form-group', errors.lower_limit? 'has-error' : '']">
    						<input type="number" class="form-control" v-model="form.lower_limit" placeholder="Enter new lower limit" min="1">
    						<span v-if="errors.lower_limit" :class="['badge bg-danger']">Please enter a valid lower limit.</span>
    					</div>
    					<div :class="['form-group', errors.upper_limit? 'has-error' : '']">
    						<input type="number" class="form-control" v-model="form.upper_limit" placeholder="Enter new upper limit" min="1">
    						<span v-if="errors.upper_limit" :class="['badge bg-danger']">Please enter a valid upper limit.</span>
    					</div>
    					<div :class="['form-group', errors.mop? 'has-error' : '']">
    						<input type="number" class="form-control" v-model="form.mop" placeholder="Enter new mop" min="1">
    						<span v-if="errors.mop" :class="['badge bg-danger']">Please enter a valid mop.</span>
    					</div>
    					<div :class="['form-group', errors.coverage_term? 'has-error' : '']">
    						<input type="number" class="form-control" v-model="form.coverage_term" placeholder="Enter new coverage term" min="1">
    						<span v-if="errors.coverage_term" :class="['badge bg-danger']">Please enter a valid coverage term.</span>
    					</div>
    					<div class="form-group">
    						<button class="btn btn-danger" @click="addService"><i class="fa fa-plus"></i> Add Service</button>
    					</div>
    				</div>
    			</div>
		</div>
	</div>
</div>
<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isSysAdmin() && !$gate.isServiceAdmin()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getServices();
        },

        data() {
        	return {
        		form: new Form({
        			item_code: '',
        			name: '',
        			aos_code: '',
        			lower_limit: '',
        			upper_limit: '',
        			mop: '',
        			coverage_term: ''
        		}),

        		services: [],
        		errors: []
        	}
        },

        methods: {
        	addService(){
        		this.form.post("/api/addService")
        		.then(response => {
        			if(response.data == 200){
        				toast.fire({
		      				icon: "success",
		      				title: "Item Added!"
		      			});
		      			this.getServices();
        			}
        		})
        		.catch((errors) => {
        			this.errors = errors.response.data.errors;
        		})
        	},

        	changeService(id, status){
        		axios.post("/api/changeService", {id: id, status: status})
        		.then(response => {
        			if(response.data == 200){
		      			this.getServices();
        			}
        		})
        	},

        	getServices(){
        		axios.post("/api/getServices")
        		.then(response => {
        			this.services = response.data;
        		})
        	},

        	itemSearch(){
        		axios.post("/api/SAPItemCodeSearch", {code: this.form.item_code, type: "code"})
        		.then(response => {
        			toast.fire({
        				icon: "warning",
        				title: "Searching..."
        			});
        			if(response.data != null){
		      			var item = response.data;
		      			//console.log(item);
		      			this.form.name = item[0].ItemName;
		      			this.form.mop = item[0].MOP;
		      		}
		      		toast.fire({
        				icon: "warning",
        				title: "Search Complete!"
        			});
        		})
        	}
        }
    }
</script>
